const escapeCsv = (value: string | number): string => {
  const text = String(value ?? '');
  if (/[",\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
};

export const toCsv = (headers: string[], rows: (string | number)[][]): string =>
  [headers, ...rows].map((row) => row.map(escapeCsv).join(',')).join('\n');

export const downloadCsv = (filename: string, headers: string[], rows: (string | number)[][]): void => {
  const blob = new Blob([`\uFEFF${toCsv(headers, rows)}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
